import { adminServerInstance } from "../axios/instances";
import { 
    GET_LOCAL_DELIVERY_ORDERS,
    GET_LOCAL_DELIVERY_ORDERS_SUCCESS,
    GET_LOCAL_DELIVERY_ORDERS_FAIL
 } from './types';

 export function getLocalDeliveryOrders() {   
    return function(dispatch) {
        dispatch({type: GET_LOCAL_DELIVERY_ORDERS})
        return adminServerInstance.get(`/business/getlocaldeliveryorders`)
        .then(({data}) => {
            dispatch({
                type: GET_LOCAL_DELIVERY_ORDERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_LOCAL_DELIVERY_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}